import { render, staticRenderFns } from "./lni-janitorial-shift-discomfort.component.vue?vue&type=template&id=3fca63fe"
import script from "./lni-janitorial-shift-discomfort.component.vue?vue&type=script&lang=js"
export * from "./lni-janitorial-shift-discomfort.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports